var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoTableCouchA = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M29.5 34.5A2.5 2.5 0 0 1 27 37H15.5a2.5 2.5 0 0 1-2.5-2.5v-10a2.5 2.5 0 0 1 2.5-2.5h14v12.5ZM47 34.5a2.5 2.5 0 0 1-2.5 2.5H33a2.5 2.5 0 0 1-2.5-2.5V22h14a2.5 2.5 0 0 1 2.5 2.5v10Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M47 32v-7.5a2.5 2.5 0 0 0-2.5-2.5h-29a2.5 2.5 0 0 0-2.5 2.5V32"
})));
SvgNoTableCouchA.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoTableCouchA);
export default ForwardRef;